import './CreateScenarioModal.css'

interface CreateScenarioModalProps {
  isOpen: boolean
  onClose: () => void
  onCreate: (name: string, description: string) => void
  name: string
  description: string
  onNameChange: (name: string) => void
  onDescriptionChange: (description: string) => void
}

export function CreateScenarioModal({
  isOpen,
  onClose,
  onCreate,
  name,
  description,
  onNameChange,
  onDescriptionChange
}: CreateScenarioModalProps) {
  if (!isOpen) return null

  const handleSubmit = () => {
    onCreate(name, description)
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Create New Scenario</h3>
          <button onClick={onClose} className="close-btn">×</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="scenario-name">Scenario Name *</label>
            <input
              id="scenario-name"
              type="text"
              placeholder="Enter scenario name"
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && name.trim() && handleSubmit()}
              className="form-input"
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="scenario-description">Description</label>
            <textarea
              id="scenario-description"
              placeholder="Describe your scenario (optional)"
              value={description}
              onChange={(e) => onDescriptionChange(e.target.value)}
              className="form-textarea"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button onClick={handleSubmit} className="submit-btn" disabled={!name.trim()}>
            Create Scenario
          </button>
        </div>
      </div>
    </div>
  )
}
